import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import useAppName from '../../hooks/useAppName';

const LogoCometeClockings = ({ sx }) => {
  const appName = useAppName();
  return (
    <Box id="logo-comete-clockings" sx={{ minWidth: 24, minHeight: 24, width: '100%', ...sx }} alt={`Logo ${appName}`}>
      <svg
        version="1.1"
        id="Calque_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1400 509"
        style={{ enableBackground: 'new 0 0 1400 509' }}
        xmlSpace="preserve"
      >
        <style type="text/css">
          {`.st0{fill:#22427C}
        .st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_)}
        .st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000054949376849979013950000008219874413350791346_)}
        .st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173122646245974557670000016395124394851370410_)}
	      .st4{fill:#677179}`}
        </style>
        <g>
          <g>
            <g>
              <g>
                <path
                  className="st0"
                  d="M104.3,310.4c-29.9,0-54.8-10-74.6-30S0,235.7,0,206c0-29.6,9.9-54.4,29.8-74.4c19.8-20,44.7-30,74.6-30
					c19.6,0,37.2,4.7,52.8,14.1s27.2,22,34.9,37.9l-29,16.7c-5-10.6-12.8-19-23.2-25.4c-10.5-6.3-22.3-9.5-35.5-9.5
					c-19.8,0-36.4,6.7-49.8,20.2s-20,30.3-20,50.4c0,19.8,6.7,36.5,20,50c13.4,13.5,30,20.2,49.8,20.2c13.2,0,25.1-3.1,35.7-9.3
					c10.6-6.2,18.6-14.6,24.2-25.2l29.4,17.1c-8.5,15.6-20.6,28.1-36.5,37.5C141.2,305.7,123.6,310.4,104.3,310.4z"
                />
                <path
                  className="st0"
                  d="M873.3,221.9c3.4,17.7,11.6,31.5,24.4,41.3c12.8,9.8,28.6,14.7,47.4,14.7c26.2,0,45.2-9.7,57.1-29
					l29.4,16.7c-19.3,29.9-48.4,44.8-87.3,44.8c-31.5,0-57.1-9.9-76.8-29.6C847.9,261.1,838,236.2,838,206c0-29.9,9.6-54.8,29-74.6
					c19.3-19.8,44.3-29.8,75-29.8c29.1,0,52.8,10.3,71.2,30.7c18.4,20.5,27.6,45.2,27.6,74c0,5-0.4,10.2-1.2,15.5H873.3V221.9z
					 M942,134.2c-18.5,0-33.9,5.2-46,15.7c-12.2,10.5-19.7,24.4-22.6,41.9h132.5c-2.9-18.8-10.3-33.1-22.2-42.8
					C971.7,139.1,957.8,134.2,942,134.2z M966.2,79.5h-33.3l-40.1-52.4h41.7L966.2,79.5z"
                />
                <path
                  className="st0"
                  d="M1179.8,140.2H1127v107.5c0,9.8,1.9,16.7,5.8,20.8c3.8,4.1,9.7,6.2,17.7,6.3c7.9,0.1,17.7-0.1,29.4-0.6
					v30.9c-30.2,4-52.2,1.5-66.3-7.3c-14-8.9-21-25.6-21-50.2V140.2h-39.3v-33.3h39.3V61.6l34.5-10.3v55.5h52.8L1179.8,140.2
					L1179.8,140.2z"
                />
                <path
                  className="st0"
                  d="M1232.6,221.9c3.4,17.7,11.6,31.5,24.4,41.3s28.6,14.7,47.4,14.7c26.2,0,45.2-9.7,57.1-29l29.4,16.7
					c-19.3,29.9-48.4,44.8-87.3,44.8c-31.5,0-57.1-9.9-76.8-29.6c-19.7-19.7-29.6-44.6-29.6-74.8c0-29.9,9.6-54.8,29-74.6
					c19.3-19.8,44.3-29.8,75-29.8c29.1,0,52.8,10.3,71.2,30.7c18.4,20.5,27.6,45.2,27.6,74c0,5-0.4,10.2-1.2,15.5h-166.2V221.9z
					 M1301.2,134.2c-18.5,0-33.9,5.2-46,15.7c-12.2,10.5-19.7,24.4-22.6,41.9h132.5c-2.9-18.8-10.3-33.1-22.2-42.8
					C1331,139.1,1317.1,134.2,1301.2,134.2z"
                />
              </g>
              <path
                className="st0"
                d="M769.5,305.2V183.3c0-25.6-20.8-46.4-46.4-46.4c-25.5,0-46.3,20.7-46.4,46.2v122.1h-34.4V183.1
				c-0.1-25.5-20.9-46.2-46.4-46.2c-25.6,0-46.4,20.8-46.4,46.4v121.9h-34.3l-0.1-125c0-44.6,36.3-80.8,80.8-80.8
				c22.8,0,44.7,9.8,60,26.9l3.6,4l3.6-4c15.3-17.1,37.2-26.9,60-26.9c44.6,0,80.8,36.3,80.8,80.8v125L769.5,305.2L769.5,305.2z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="st0"
            d="M168.4,0.3l106.8,243.3c17.2,39.2,55.8,64.4,98.3,64.4c0.6,0,1.1,0,1.7,0c59.3-0.9,106.7-50,105.8-109.5
		c-0.7-43.3-27.1-82.1-67.1-98.3L168.4,0.3L168.4,0.3z"
          />
        </g>
        <radialGradient
          id="SVGID_1_"
          cx="2956.4053"
          cy="-544.6465"
          r="10.1461"
          gradientTransform="matrix(12.5981 0 0 12.7234 -37073.6445 6929.9673)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style={{ stopColor: '#F6D73C' }} />
          <stop offset="1" style={{ stopColor: '#EEBD36' }} />
        </radialGradient>
        <path
          className="st1"
          d="M399.3,219.9h-19.8v-28c0-0.3-0.2-0.5-0.5-0.5h-6.7c-0.3,0-0.5,0.2-0.5,0.5v28.4v6.8c0,0.3,0.2,0.5,0.5,0.5h27
	c0.3,0,0.5-0.2,0.5-0.5v-6.8C399.8,220.1,399.6,219.9,399.3,219.9z"
        />
        <radialGradient
          id="SVGID_00000124158547237881979490000005031845952572801205_"
          cx="2956.4058"
          cy="-544.6462"
          r="10.1461"
          gradientTransform="matrix(12.5981 0 0 12.7235 -37073.6445 6930.0176)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style={{ stopColor: '#F6D73C' }} />
          <stop offset="1" style={{ stopColor: '#EEBD36' }} />
        </radialGradient>
        <path
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: 'url(#SVGID_00000124158547237881979490000005031845952572801205_)'
          }}
          d="
	M422.7,120.8c0-0.9-0.7-1.7-1.7-1.7h-85.8c-0.9,0-1.7,0.7-1.7,1.7v24h89L422.7,120.8L422.7,120.8z"
        />
        <radialGradient
          id="SVGID_00000072983309638898739510000014688022273259697804_"
          cx="2967.8845"
          cy="-532.4913"
          r="10.1461"
          gradientTransform="matrix(12.5981 0 0 12.7234 -37057.832 6946.8774)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style={{ stopColor: '#F6D73C' }} />
          <stop offset="1" style={{ stopColor: '#EEBD36' }} />
        </radialGradient>
        <path
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: 'url(#SVGID_00000072983309638898739510000014688022273259697804_)'
          }}
          d="
	M438.7,157.9h-121c-0.9,0-1.7,0.7-1.7,1.7v119.6c15,11.1,33,17.7,52.2,18.3h6.3c26.1-0.8,49.2-12.4,65.7-30.6V159.5
	C440.2,158.6,439.5,157.9,438.7,157.9z M376.9,261.3c-21.1,0-38.1-17.4-38.1-38.8s17-38.8,38.1-38.8s38.1,17.4,38.1,38.8
	C415,243.8,397.9,261.3,376.9,261.3z"
        />
        <g>
          <path
            className="st4"
            d="M697.1,454.6c0.1-15.2,5.3-28,15.5-38.4c9.9-10.5,22.9-15.9,39.1-16.2c16.3,0.3,29.4,5.7,39.4,16.2
		c10.1,10.4,15.2,23.2,15.3,38.5c-0.1,15.2-5.1,27.9-14.9,38.2c-9.6,10.5-22.9,15.9-39.7,16.2c-16.7-0.3-29.8-5.7-39.4-16.2
		C702.2,482.5,697.2,469.7,697.1,454.6z M751.7,416.7c-9.9,0.1-18.3,3.7-25.2,10.6c-7.1,7.1-10.7,16.2-10.9,27.3
		c0.2,10.2,3.8,19,10.9,26.2c6.9,7.5,15.3,11.3,25.2,11.4c10.1-0.1,18.6-3.9,25.5-11.4c6.9-7.2,10.5-16,10.6-26.2
		c-0.1-11.1-3.7-20.2-10.6-27.3C770.3,420.4,761.8,416.8,751.7,416.7z"
          />
          <path
            className="st4"
            d="M902.6,446c0-8.2-1.7-15-5.2-20.7c-1.7-2.7-4-4.8-7-6.5c-3.1-1.4-6.9-2.2-11.3-2.2
		c-17.2,0.3-25.9,10.7-26.1,31.2v58.7h-17.4V402.4H853v12.2h0.4c2.8-4.8,6.7-8.5,11.6-11c5-2.4,10.3-3.6,16.1-3.6
		c10.2,0,19.1,3,26.9,8.9c7.8,6.2,11.8,16.4,12,30.4v67.4h-17.4V446z"
          />
          <path
            className="st4"
            d="M1006.6,377.2h17.4v25.2h16.1v15.8H1024v64c0,2.7,0.6,4.6,1.9,5.9c1.2,1.2,3.4,1.8,6.6,1.8h8v16.6
		c-2.7,0.1-6.3,0.2-10.7,0.2c-8.7,0-14.8-1.7-18.1-5.2c-3.5-3.6-5.2-9.4-5.1-17.2v-66h-14v-15.8h14V377.2z"
          />
          <path
            className="st4"
            d="M1059.3,369.3c0-3.7,1.2-6.7,3.7-9c2.3-2.3,5.1-3.5,8.5-3.6c3.6,0.1,6.5,1.3,8.7,3.6c2.2,2.3,3.4,5.3,3.5,9
		c-0.1,3.5-1.3,6.4-3.5,8.8c-2.2,2.5-5.1,3.8-8.7,3.8c-3.4,0-6.2-1.3-8.5-3.8C1060.5,375.7,1059.3,372.8,1059.3,369.3z
		 M1062.7,402.4h17.4v104.2h-17.4V402.4z"
          />
          <path
            className="st4"
            d="M1242.2,442.7c-0.1-9.1-2.4-15.8-6.7-19.9c-4.5-4.1-10-6.2-16.4-6.2c-7.7,0-14,2.2-18.8,6.6
		c-5.1,4.7-7.7,11.4-7.7,20.2v63.1h-17.4v-63.8c-0.2-9.1-2.4-15.7-6.7-19.8c-4.5-4.1-10-6.2-16.4-6.2c-7.7,0-14,2.2-18.8,6.6
		c-5.1,4.7-7.7,11.4-7.7,20.2v63.1h-17.4V402.4h17.4v12.4h0.4c2.7-5.3,6.7-9.2,12.2-11.6c5.5-2.1,11-3.2,16.6-3.2
		c5.5-0.1,10.9,0.9,16.4,3.2c5.3,2.4,10.1,7.3,14.4,14.8c3.5-6.5,8.3-11.2,14.5-14c6.1-2.7,12.6-4,19.5-4c11.5,0,20.9,3.4,28.4,10.1
		c7.6,6.8,11.5,17,11.6,30.8v65.8h-17.4V442.7z"
          />
          <path
            className="st4"
            d="M1386.5,486.4c-13.2,15.2-28.3,22.8-45.5,22.6c-17.8-0.3-31.5-6-40.9-17c-9.5-10.8-14.2-23.3-14.2-37.6
		c0.1-15.2,4.9-28.1,14.4-38.5c9.3-10.4,21.8-15.7,37.7-16c15.9,0.2,28.6,5.8,38.1,16.9c9.7,11,14.6,25.9,14.8,44.6h-86.4
		c1.5,8.9,5.5,16.1,12,21.7c6.3,5.9,14.4,8.9,24.3,9.1c12.5-0.1,23.3-5.7,32.4-16.8L1386.5,486.4z M1371.2,446.6
		c-0.9-8.9-4.4-16.1-10.4-21.8c-6-5.3-13.6-8-22.9-8.1c-10.6,0.1-18.6,3.3-23.9,9.4c-5.4,6.1-8.6,13-9.5,20.5H1371.2z"
          />
        </g>
      </svg>
    </Box>
  );
};
LogoCometeClockings.propTypes = {
  sx: PropTypes.object
};

export default LogoCometeClockings;
